import axios from 'axios';

import { type Common } from '../common.js';
import { type ComponentsJsonResponseWithCompactStr } from '../models/predict/vision.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async getRecognizedComponents(
    gsPath: string,
    version?: string,
    ehrInstance?: string
  ): Promise<ComponentsJsonResponseWithCompactStr> {
    const url = this.common.constructPath(`/predict/vision/ui/components`, {
      gsPath,
      version,
      ehrInstance,
    });
    return await this.common.getJSON(url);
  }

  async getMultistageModelVersions(): Promise<string[]> {
    const url = this.common.constructPath('/predict/vision/ui/multistage/versions');
    const { versions } = await this.common.getJSON(url);
    return versions;
  }

  async getSignedUploadUrlPredict(
    folder: string,
    dataId: string
  ): Promise<{ signedUploadUrl: string; fullGsPath: string }> {
    const url = this.common.constructPath(`/predict/vision/signed-upload-url`, {
      folder,
      dataId,
    });
    return await this.common.getJSON(url);
  }

  async upload(
    file: Blob,
    signedUploadURL: string,
    contentType: string = 'image/png'
  ): Promise<number> {
    const response = await axios.put(signedUploadURL, file, {
      headers: {
        'Content-Type': contentType,
      },
      timeout: 30000,
    });
    return response.status;
  }
}
